module.exports = __webpack_public_path__ + "static/media/consultoria.54db680b.svg";